'use client';

import React from 'react';
import SearchInput from '../@generalComponents/SearchInput';
import { useMediaQuery, useTheme } from '@mui/material';

const SecondaryFooter = () => {
	const theme = useTheme();
	const isMediumScreen = useMediaQuery(theme.breakpoints.down('md'));

	return (
		<div className='bg-[#00BFFF] mb-0 p-6 md:p-12'>
			<div className='flex justify-center'>
				<div className='w-full md:w-7/12'>
					<h2 className='mb-3 text-center font-bold text-xl md:text-2xl'>
						The world's #1 search engine for text messages
					</h2>
					<h3 className='mb-3 text-center text-base md:text-lg'>
						Follow, save and share texts from your favorite brands
					</h3>
					<div className='flex justify-center'>
						<SearchInput
							navigateToSearchPage
							width={isMediumScreen ? '100%' : '75%'}
						/>
					</div>
				</div>
			</div>
		</div>
	);
};

export default SecondaryFooter;
